import { $gettext } from '@/config/gettext'

const primary = [
  // {
  //   label: $gettext('Deals'),
  //   routeName: 'Private/Home'
  // },
  {
    label: $gettext('Packages'),
    routeName: 'Private/Package/Search',
    routeParams: { DistributionChannel: 2 }
  },
  {
    label: $gettext('Tours'),
    routeName: 'Private/TourCache'
  },
  // {
  //   label: $gettext('Senior Voyage'),
  //   routeName: 'Private/Package/Search',
  //   routeParams: { DistributionChannel: 3 }
  // },
  {
    label: $gettext('Senior Voyage'),
    routeName: 'Private/Tour/Search',
    routeParams: { DistributionChannel: 2 }
  },
  {
    label: $gettext('Hotels CHR'),
    routeName: 'Private/Hotel'
  },
  {
    label: $gettext('Excursions'),
    routeName: 'Private/Other'
  },
  {
    label: $gettext('Bookings'),
    routeName: 'Private/Bookings'
  },
  {
    label: $gettext('Account'),
    routeName: 'Private/Account'
  }
]

const secondary = [
  {
    label: $gettext('log out'),
    routeName: 'Private/Logout',
    icon: 'power'
  }
]

export {
  primary,
  secondary
}
